import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Removes a parcel in a `}<a parentName="p" {...{
          "href": "/api/../api/projects/orders#delivery"
        }}>{`Delivery`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"removeParcelFromDelivery"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`parcelId`}</inlineCode>{` - String - ID of the `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#parcel"
          }}>{`Parcel`}</a>{` which shall be removed`}</li>
      </ul>
      <p parentName="section">{`This update action produces a `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#parcel-removed-from-delivery"
        }}>{`ParcelRemovedFromDelivery`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      